import fetch from 'isomorphic-fetch';
import { SmartRec } from '../lib/constants';
import { clientLogger } from '../../client/lib/logger';

function updateRecommendedTools(recommendations = []) {
  return {
    type: SmartRec.UPDATE_RECOMMENDED_TOOLS,
    recommendations
  };
}

/**
 * Fetch recommended tools from smartrec
 */
function getRecommendedTools(headers = {}) {
  let url = `/smartrec/api/v1/partnerportalmetadata?placements=SmartRec_Partner_Portal&messageCount=-1`;

  if (headers.merchantHubHost) {
    url = headers.merchantHubHost + url;
  }

  return fetch(url, {
    method: 'GET',
    credentials: 'same-origin',
    headers
  }).then(res => {
    return res.ok ? Promise.resolve(res.json()) : Promise.reject(res.json());
  });
}

export function fetchRecommendedTools(_params, _query, headers) {
  return dispatch =>
    getRecommendedTools(headers)
      .then(data => {
        dispatch(updateRecommendedTools(data || []));
      })
      .catch(err => {
        clientLogger.warn('error getting tools from smartrec', err);
      });
}
